import React from 'react';

import { SimpleTag as Tag } from '@atlaskit/tag';

export default (): React.JSX.Element => <Tag text="Tag link" href="/components/tag" />;
